import { z } from "zod";
import { isZipCodeValidForState } from "helpers/stateZipCodeMapping";

const toText = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  return value;
};

const requiredText = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
  );

const requiredEmail = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
      .email("Invalid email")
  );

const optionalText = z.preprocess(
  (value) => {
    if (value == null || value === "") return undefined;
    return value;
  },
  z.string().optional()
);

const requiredDate = (label) =>
  z.preprocess(
    (value) => {
      if (value === "" || value == null) return undefined;
      const parsed = value instanceof Date ? value : new Date(value);
      return parsed;
    },
    z.date({
      required_error: `${label} is required`,
      invalid_type_error: `${label} is required`,
    })
  );

export const Step2Schema = z
  .object({
    firstName: requiredText("First name"),
    lastName: requiredText("Last name"),
    dateOfBirth: requiredDate("Date of birth"),
    gender: requiredText("Gender"),
    email: requiredEmail("Insured email"),
    phone: requiredText("Phone"),
    address1: requiredText("Address"),
    address2: optionalText,
    city: requiredText("City"),
    state: requiredText("State"),
    zip: requiredText("Zip"),
    movedRecently: z.boolean().default(false),
    priorAddress: optionalText,
    priorCity: optionalText,
    priorState: optionalText,
    priorZip: optionalText,
  })
  .superRefine((data, ctx) => {
    if (!isZipCodeValidForState(data.state, data.zip)) {
      ctx.addIssue({
        code: "custom",
        path: ["zip"],
        message: "This zip code is not valid for this state.",
      });
    }

    if (data.movedRecently) {
      if (!String(data.priorAddress || "").trim()) {
        ctx.addIssue({
          code: "custom",
          path: ["priorAddress"],
          message: "Prior address is required",
        });
      }
      if (!String(data.priorCity || "").trim()) {
        ctx.addIssue({
          code: "custom",
          path: ["priorCity"],
          message: "Prior city is required",
        });
      }
      if (!String(data.priorState || "").trim()) {
        ctx.addIssue({
          code: "custom",
          path: ["priorState"],
          message: "Prior state is required",
        });
      }
      if (!String(data.priorZip || "").trim()) {
        ctx.addIssue({
          code: "custom",
          path: ["priorZip"],
          message: "Prior zip is required",
        });
      }
    }

    if (
      data.movedRecently &&
      !isZipCodeValidForState(data.priorState, data.priorZip)
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["priorZip"],
        message: "This zip code is not valid for this state.",
      });
    }
  });
